import React from "react";
import CandidatePreview from "../CandidatePreview";
import { Button, Space, Typography } from "antd";
import {
  FacebookOutlined,
  InstagramOutlined,
  TwitterOutlined,
  YoutubeOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import { objectIsEmpty } from "../../../helpers";
import AdHelper from "../../shared/ad/AdHelper";

const { Text } = Typography;

const safeJSONParse = (value, fallback = null) => {
  try {
    if (!value || value === "undefined" || value === "null") return fallback;
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const BioLeft = (props) => {
  const { bio, source } = props.details || {};
  const social = bio?.social || {};
  const contact = bio?.contact || {};

  let cityState = "";
  if (typeof contact.address === "string" && contact.address.trim() !== "") {
    const officeContact = contact.address.split(",");
    const contactLength = officeContact.length;
    const city = officeContact[contactLength - 3];

    cityState =
      contactLength > 1
        ? `${city ? city + ", " : ""}${officeContact[contactLength - 2] || ""}`
        : "";
  }

  const isLoggedIn = Boolean(safeJSONParse(localStorage.getItem("user"), null));

  return (
    <Space
      direction="vertical"
      size="middle"
      style={{ textAlign: "center", width: "100%" }}
      align="center"
    >
      <CandidatePreview details={props.details} buttonVisibility={true} />

      {!objectIsEmpty(social) ? (
        <>
          {isLoggedIn && (
            <Text strong underline>
              General
            </Text>
          )}

          <Space
            direction="horizontal"
            style={{ width: "100%", justifyContent: "center" }}
          >
            {social.website ? (
              <Button
                style={{ borderColor: "#bfbfbf" }}
                className="btn-bordered"
                size="small"
                href={social.website}
                icon={<HomeOutlined />}
              />
            ) : null}

            {social.facebook && source === "nocap-auto-loader" ? (
              <Button
                style={{ borderColor: "#bfbfbf" }}
                className="btn-bordered"
                size="small"
                href={`https://wwww.facebook.com/${social.facebook}`}
                icon={<FacebookOutlined />}
              />
            ) : null}

            {social.facebook && source !== "nocap-auto-loader" ? (
              <Button
                style={{ borderColor: "#bfbfbf" }}
                size="small"
                className="btn-bordered"
                href={`https://wwww.facebook.com`}
                icon={<FacebookOutlined />}
              />
            ) : null}

            {social.instagram && source === "nocap-auto-loader" ? (
              <Button
                style={{ borderColor: "#bfbfbf" }}
                size="small"
                className="btn-bordered"
                href={`https://www.instagram.com/`}
                icon={<InstagramOutlined />}
              />
            ) : null}

            {social.instagram && source !== "nocap-auto-loader" ? (
              <Button
                style={{ borderColor: "#bfbfbf" }}
                size="small"
                className="btn-bordered"
                href={`https://www.instagram.com/`}
                icon={<InstagramOutlined />}
              />
            ) : null}

            {social.twitter && source === "nocap-auto-loader" ? (
              <Button
                style={{ borderColor: "#bfbfbf" }}
                size="small"
                className="btn-bordered"
                href={`https://twitter.com/${social.twitter}`}
                icon={<TwitterOutlined />}
              />
            ) : null}

            {social.twitter && source !== "nocap-auto-loader" ? (
              <Button
                style={{ borderColor: "#bfbfbf" }}
                size="small"
                className="btn-bordered"
                href={social.twitter}
                icon={<TwitterOutlined />}
              />
            ) : null}

            {social.youtube && source === "nocap-auto-loader" ? (
              <Button
                style={{ borderColor: "#bfbfbf" }}
                size="small"
                className="btn-bordered"
                href={`https://www.youtube.com/${social.youtube}`}
                icon={<YoutubeOutlined />}
              />
            ) : null}

            {social.youtube && source !== "nocap-auto-loader" ? (
              <Button
                style={{ borderColor: "#bfbfbf" }}
                size="small"
                className="btn-bordered"
                href={social.youtube}
                icon={<YoutubeOutlined />}
              />
            ) : null}
          </Space>
        </>
      ) : null}

      {contact.address || contact.phone || contact.email || contact.fax ? (
        <Space direction="vertical">
          {isLoggedIn && (
            <Text strong underline>
              Office Contacts
            </Text>
          )}

          {contact.address ? (
            <>
              <Text>Address</Text>
              <Text type="secondary">{cityState}</Text>
            </>
          ) : null}

          {contact.phone ? (
            <>
              <Text>Phone</Text>
              <Text type="secondary">{contact.phone}</Text>
            </>
          ) : null}

          {contact.email ? (
            <>
              <Text>Email</Text>
              <div style={{ flexDirection: "row", flexWrap: "wrap", width: "250px" }}>
                <Text type="secondary">{contact.email}</Text>
              </div>
            </>
          ) : null}

          {contact.fax ? (
            <>
              <Text>Fax</Text>
              <Text type="secondary">{contact.fax}</Text>
            </>
          ) : null}
        </Space>
      ) : null}

      <AdHelper page="news-post" position="left" />
    </Space>
  );
};

export default BioLeft;
